import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import "./HomeNavbarmenu.css";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { onChange } from "../Redux/SearchSlice";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import HelpIcon from '@mui/icons-material/Help';
import HistoryIcon from '@mui/icons-material/History';
import { saveSearchHistory } from "../../utils/localSearRecords";

const HomeNavbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const [input, setInput] = useState("")
  const [remove, setRemove] = useState(false)
  const [suggestion, setSuggestion] = useState(false)
  const [searchHistory, setSearchHistory] = useState([]);

  useEffect(() => {
    const history = JSON.parse(localStorage.getItem("search_history"))
    if (history) {
      setSearchHistory(history)
    }

  }, [])

  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }
  const hide = () => setisMenu(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  // const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  // const toggleSubmenu = () => {
  //   setMenuSubMenu(isMenuSubMenu === false ? true : false);
  // };
  // let boxClassSubMenu = ["sub__menus"];
  // if (isMenuSubMenu) {
  //   boxClassSubMenu.push("sub__menus__Active");
  // } else {
  //   boxClassSubMenu.push("");
  // }

  const [activeMenu, setActiveMenu] = useState(null);


  const dispatch = useDispatch();

  const handleInputChange = () => {
    if (input && input.trim() !== "") {
      dispatch(onChange(input))
      setRemove(true)
      setSuggestion(false)
      //
      const history = saveSearchHistory(input);
      setSearchHistory(history); // optional state
      //
    }
  }
  const handleInputChange1 = () => {
    setInput("")
    setRemove(!remove);
    if (input) {
      dispatch(onChange())
      // //
      //   const history = saveSearchHistory(input);
      //   setSearchHistory(history); // optional state
      // //
      setSuggestion(false)
    }
  }
  const handleInputChange2 = (data) => {
    setInput(data)
    if (data) {
      dispatch(onChange(data))
      //
      const history = saveSearchHistory(data);
      setSearchHistory(history); // optional state
      //

      setRemove(true);
      setSuggestion(false)
    }
  }
  const handleSearchHistory = (e) => {
    e.preventDefault()
    let history = []
    localStorage.setItem("search_history", JSON.stringify(history))
    setSearchHistory([]);
  }
  const deleteInput = (item) => {
    const history = searchHistory.filter((i) => item !== i)
    localStorage.setItem("search_history", JSON.stringify(history))

    setSearchHistory(history);
  }
  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    role="button"
                    tabIndex={0}
                    aria-haspopup="true"
                    aria-expanded="false"
                    type="button"
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    {" "}
                    <FiXCircle />{" "}
                  </span>
                </>
              ) : (
                <>
                  <span
                    role="button"
                    tabIndex={0}
                    aria-haspopup="true"
                    aria-expanded="false"
                    type="button"
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    {" "}
                    <FiAlignRight />{" "}
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
                <li className="menu-item">
                  <NavLink
                    to="/Home"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      L&TT <br /> Home
                    </span>
                    {/* <img
                      src="images/Home/home-active-icon.png"
                      alt="home"
                      className="hovering-home"
                    /> */}
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Academies-Tracks"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Academies <br /> & Tracks
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/AI-Academy"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      AI <br /> Academy
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Role-Aligned-Curriculum"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Role-Aligned <br /> Curriculum
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Learning-Calendar"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Learning <br /> Calendar
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/Programs-Certifications"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    {" "}
                    <span>
                      Programs <br /> & Certifications
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    to="/LTT-Podcast"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      L&TT <br /> Podcast
                    </span>
                  </NavLink>
                </li>
                <li className="menu-item">
                  <a
                    href="https://mml.accenture.com/home"
                    activeClassName="is-active"
                    className="nav-links"
                    target="_blank"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      Learners <br /> Feedback
                    </span>
                  </a>
                </li>

                {/* <li className="menu-item">
                  <NavLink
                    to="/About-LTT"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                  >
                    <span>
                      About <br /> L&TT
                    </span>
                  </NavLink>
                </li> */}

                <li
                  className="menu-item menu-item-has-children"
                  onMouseEnter={() => setActiveMenu("keylinks")}
                  onMouseLeave={() => setActiveMenu(null)}
                >
                  <a
                    // to="/Home"
                    href="javascript:void(0)"
                    // activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                    aria-expanded={activeMenu === "keylinks"}
                    aria-haspopup="true"
                  >
                    <span>
                      Key <br /> Links <FiChevronDown />
                    </span>
                  </a>
                  <ul
                    className={`sub__menus ${activeMenu === "keylinks" ? "sub__menus__Active" : ""
                      }`}
                  >
                    <li>
                      <a
                        href="https://reinventionconsole.accenture.com/console/"
                        target="blank"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Accenture Reinvention Console
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://cop.accenture.com/#/global"
                        target="blank"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Community of Practices
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://mycredential.accenture.com/"
                        target="blank"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        myCredential
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://ts.accenture.com/sites/ReinventionAgenticAI/SitePages/Home.aspx"
                        target="blank"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Reinvention with Agentic AI
                      </a>
                    </li>
                  </ul>
                </li>

                <li
                  className="menu-item menu-item-has-children"
                  onMouseEnter={() => setActiveMenu("about")}
                  onMouseLeave={() => setActiveMenu(null)}
                >
                  <NavLink
                    to="/About-LTT"
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    exact
                    aria-expanded={activeMenu === "about"}
                    aria-haspopup="true"
                  >
                    <span>
                      About <br /> L&TT <FiChevronDown />
                    </span>
                  </NavLink>
                  <ul
                    className={`sub__menus ${activeMenu === "about" ? "sub__menus__Active" : ""
                      }`}
                  >
                    <li>
                      <a
                        href="/About-LTT#Our-Expertise"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Our Expertise
                      </a>
                    </li>
                    <li>
                      <a
                        href="/About-LTT#Our-Leads"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Our Leads
                      </a>
                    </li>
                    <li>
                      <a
                        href="/About-LTT#Awards"
                        className="sub-nav-link"
                        activeClassName="is-active"
                        onClick={toggleClass}
                      >
                        Awards
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="menu-item menu-regular">
                  <div className="searbar-nav">
                    <input type="text"
                      value={input ? input : ""}
                      onFocus={() => setSuggestion(true)}
                      onBlur={() => setTimeout(() => {
                        setSuggestion(false)
                      }, 400)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleInputChange()
                        }
                      }}
                      onChange={(e) => setInput(e.target.value)}
                      className="search-micro" placeholder="What do you want to learn? " />
                    {/* <img width={25} src={`${process.env.PUBLIC_URL}/images/Home/microphone.png`}/> */}
                    {remove ? <ClearIcon style={{ cursor: 'pointer', color: "grey" }} onClick={() => handleInputChange1()} /> : null}
                    <SearchIcon className="search-icon" onClick={handleInputChange} />
                  </div>
                  {suggestion && <div className="menu-list-absolute">
                    {searchHistory?.length > 0 && <div className="rm-history-btn" onClick={(e) => handleSearchHistory(e)}>Clear Search history <HelpIcon style={{ width: '0.62em', marginLeft: '0.2em' }} /></div>}
                    {searchHistory?.length > 0 && searchHistory?.map((i) => (
                      <>
                        <div className="space-btw">
                          <span style={{ width: '65%', display: "flex", alignItems: "center", cursor: 'pointer' }}>
                            <HistoryIcon className="md-history" />
                            <span onClick={(e) => handleInputChange2(i)}>{i}</span>
                          </span>
                          <span className="rm-btn" onClick={() => deleteInput(i)}>Remove</span>
                        </div></>
                    ))
                    }
                    <div className="head-md">
                      <span>TOP TRENDING</span>
                      <hr className="margin-sm" />
                    </div>
                    <div className="space-btw" onClick={(e) => { e.stopPropagation(); handleInputChange2("Artificial Intelligence") }}>
                      <p>Artificial Intelligence</p>
                    </div>
                    <div className="space-btw" onClick={() => handleInputChange2("Data Analytics")}>
                      <p>Data Analytics</p>
                    </div>
                  </div>}
                </li>


                {/* {allowedUsers.includes(loggedInEnterpriseId) && (
                  <li className="menu-item">
                    <NavLink
                      to="/Reviews"
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={toggleClass}
                      exact
                    >
                      <span>
                        Admin <br /> Feedback
                      </span>
                    </NavLink>
                  </li>
                )} */}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HomeNavbarmenu;
